namespace h5_vm {
   export enum VmDisplayMode {
      CreateMode,
      ReadMode,
      ReadAdvancedMode,
      UpdateMode
   }
}
